"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantRefundErrorType = exports.MerchantRefundStatus = exports.CashToMerchantErrorType = exports.CashToMerchantWelcomeFlowStep = exports.RiskRating = exports.MINIMUM_AMOUNT_REQUIRED_TO_CREATE_FIXED_PLAN = void 0;
// We cannot create a fixed plan for small dollar amounts. This is the minimum amount required.
exports.MINIMUM_AMOUNT_REQUIRED_TO_CREATE_FIXED_PLAN = 200;
/**
 * Risk classification of an AvenVerifiedMerchant. Drives the pre-funding cash-to-merchant experience:
 * HighRisk merchants skip the welcome survey and are routed straight to a mandatory HIL welcome call,
 * while Default merchants take the survey and are only routed to the call on a subpar response.
 * Persisted on AvenVerifiedMerchant.riskRating (varchar).
 */
var RiskRating;
(function (RiskRating) {
    RiskRating["Default"] = "Default";
    RiskRating["HighRisk"] = "HighRisk";
})(RiskRating || (exports.RiskRating = RiskRating = {}));
/**
 * What the customer still owes before they can fund a pending cash-to-merchant payment.
 * Decided entirely on the backend so the frontend only has to route, never to re-derive the rule.
 */
var CashToMerchantWelcomeFlowStep;
(function (CashToMerchantWelcomeFlowStep) {
    /** Nothing owed — go straight into the cash-out payment flow. */
    CashToMerchantWelcomeFlowStep["none"] = "none";
    /** Customer must take the pre-funding welcome survey and its answers decide whether a call is then required. */
    CashToMerchantWelcomeFlowStep["survey"] = "survey";
    /** A mandatory HIL welcome call is owed and the welcome survey is skipped. */
    CashToMerchantWelcomeFlowStep["call"] = "call";
})(CashToMerchantWelcomeFlowStep || (exports.CashToMerchantWelcomeFlowStep = CashToMerchantWelcomeFlowStep = {}));
var CashToMerchantErrorType;
(function (CashToMerchantErrorType) {
    CashToMerchantErrorType["PROJECT_NOT_FOUND"] = "PROJECT_NOT_FOUND";
    CashToMerchantErrorType["UNAUTHORIZED_PROJECT_ACCESS"] = "UNAUTHORIZED_PROJECT_ACCESS";
    CashToMerchantErrorType["MERCHANT_BANK_ACCOUNT_NOT_FOUND"] = "MERCHANT_BANK_ACCOUNT_NOT_FOUND";
    CashToMerchantErrorType["BANK_ACCOUNT_SETUP_FAILED"] = "BANK_ACCOUNT_SETUP_FAILED";
    CashToMerchantErrorType["INVALID_TRANSFER_DATE"] = "INVALID_TRANSFER_DATE";
    CashToMerchantErrorType["LOAN_APPLICATION_NOT_APPROVED"] = "LOAN_APPLICATION_NOT_APPROVED";
    CashToMerchantErrorType["PENDING_REQUEST_ALREADY_EXISTS"] = "PENDING_REQUEST_ALREADY_EXISTS";
    CashToMerchantErrorType["UNACKNOWLEDGED_PAYMENT_EXISTS"] = "UNACKNOWLEDGED_PAYMENT_EXISTS";
    /**
     * @deprecated No longer emitted: completed projects can request cash. Kept for existing API consumers and the
     * exhaustive handling sites that switch on this enum. Not persisted anywhere.
     */
    CashToMerchantErrorType["PROJECT_ALREADY_COMPLETE"] = "PROJECT_ALREADY_COMPLETE";
    // HIL Rewards only: the contractor tier's draw window (days since credit card account creation) has expired.
    CashToMerchantErrorType["DRAW_WINDOW_EXPIRED"] = "DRAW_WINDOW_EXPIRED";
    CashToMerchantErrorType["INSUFFICIENT_AVAILABLE_CREDIT"] = "INSUFFICIENT_AVAILABLE_CREDIT";
    CashToMerchantErrorType["TRANSACTION_PERMISSION_DENIED"] = "TRANSACTION_PERMISSION_DENIED";
})(CashToMerchantErrorType || (exports.CashToMerchantErrorType = CashToMerchantErrorType = {}));
/**
 * Lifecycle of a merchant-initiated refund (HIL contractor refunds a cardholder). Balance drops on Posted; available
 * credit returns when the payment's OTB hold expires. A debit return (NSF/R-code) moves it to Returned.
 */
var MerchantRefundStatus;
(function (MerchantRefundStatus) {
    MerchantRefundStatus["Pending"] = "Pending";
    MerchantRefundStatus["AciSubmissionSuccess"] = "AciSubmissionSuccess";
    MerchantRefundStatus["Posted"] = "Posted";
    MerchantRefundStatus["Returned"] = "Returned";
    MerchantRefundStatus["Failed"] = "Failed";
})(MerchantRefundStatus || (exports.MerchantRefundStatus = MerchantRefundStatus = {}));
var MerchantRefundErrorType;
(function (MerchantRefundErrorType) {
    MerchantRefundErrorType["CLIENT_NOT_FOUND"] = "CLIENT_NOT_FOUND";
    MerchantRefundErrorType["UNAUTHORIZED_ACCESS"] = "UNAUTHORIZED_ACCESS";
    MerchantRefundErrorType["MISSING_REFUND_PERMISSION"] = "MISSING_REFUND_PERMISSION";
    MerchantRefundErrorType["MERCHANT_BANK_ACCOUNT_NOT_FOUND"] = "MERCHANT_BANK_ACCOUNT_NOT_FOUND";
    MerchantRefundErrorType["BANK_ACCOUNT_SETUP_FAILED"] = "BANK_ACCOUNT_SETUP_FAILED";
    MerchantRefundErrorType["ACCOUNT_NOT_REFUNDABLE"] = "ACCOUNT_NOT_REFUNDABLE";
    MerchantRefundErrorType["AMOUNT_EXCEEDS_REFUNDABLE"] = "AMOUNT_EXCEEDS_REFUNDABLE";
    MerchantRefundErrorType["INVALID_AMOUNT"] = "INVALID_AMOUNT";
})(MerchantRefundErrorType || (exports.MerchantRefundErrorType = MerchantRefundErrorType = {}));
